// extracted by css-extract-rspack-plugin
export default {"option":"option-1TJc0","selectedIcon":"selectedIcon-1OOt9","isHighlighted":"isHighlighted-3fpEz"};